export default __webpack_public_path__ + "static/media/withlogo.007.d477786b.jpeg";